import { minBreakpoints, responsiveFontSize, theme } from '@noths/polaris-client-ribbons-base';
import {
  LINK_CAROUSEL__HEADING_CLASS,
  LINK_CAROUSEL__LIST_CLASS,
} from '@noths/polaris-client-ribbons-design-system';
import { mediaQuery, pxToRem, stack } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { spacing, text } = theme;

export const accordionContent = css`
  display: none;
  margin-top: ${pxToRem(24)};

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      display: block;
    `,
  )};

  &[data-open='false'] {
    display: none;
  }

  &[data-open='true'] {
    display: block;
  }
`;

export const icon = css`
  visibility: hidden;

  &:hover {
    background: none;
  }

  &[aria-expanded] {
    visibility: visible;
  }
`;

export const toggleButton = css`
  background: none;
  color: inherit;
  border: none;
  font: inherit;
`;

export const copyBlockContent = css`
  overflow: auto;
  display: flex;
  justify-content: center;

  a {
    color: var(--brand-purple-base);
  }
  p {
    max-width: ${pxToRem(776)};
    margin: 0;
    color: var(--neutral-black-base);
  }
`;

export const headerCopyBlock = css`
  margin: ${stack(spacing.xl)};
  text-align: center;

  h1 {
    text-transform: capitalize;
    color: var(--neutral-black-base);
    ${responsiveFontSize({
      XXS: text.HEADING.LG,
      L: text.HEADING.XL,
    })};
    font-weight: 600;
  }

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      margin: ${stack(0)};
    `,
  )};
`;

export const heading = css`
  display: inline;
  margin-right: ${pxToRem(12)};
`;

export const linksCarouselSection = css`
  display: flex;
  justify-content: center;
`;

export const insetSectionContent = css`
  max-width: 776px;
`;

export const linksCarouselWrapper = css`
  width: 100%;
  margin: ${pxToRem(36)} 0 ${pxToRem(12)};

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      margin: ${pxToRem(36)} 0 ${pxToRem(36)};
    `,
  )};

  .${LINK_CAROUSEL__LIST_CLASS} {
    margin: ${pxToRem(spacing.sm)} 0;
  }

  .${LINK_CAROUSEL__HEADING_CLASS} {
    margin: 0;
  }
`;
